export default "__VITE_ASSET__NEWVwErZ__"